export enum QueryStringParams {
  Keyword = `keyword`,
  SortOrder = `sortOrder`,
  Results = `results`,
  FacetPrefix = `facet-`,
  ShowComparison = `showCompare`,
  ErrorMessage = `errorMessage`,
}
